import { get } from 'utils/lodash'
import { formatMillisecondsToTime } from 'utils/time'

export const getExceptionDate = exception => {
  const transactedAt = get(exception, 'transactedAt')
  const createdAt = get(exception, 'createdAt')
  return transactedAt || createdAt
}

export const getExceptionDelayTimeFormatted = exception => {
  const delayTime = get(exception, 'delayTime')
  return delayTime > 0 ? formatMillisecondsToTime(delayTime) : ''
}
